export const APP_ERROR = "APP_ERROR";
export const CLEAR_APP_ERRORS = "CLEAR_APP_ERRORS";
export const REHYDRATION_COMPLETE = "REHYDRATION_COMPLETE";

export const ROUTE_CHANGE = "ROUTE_CHANGE";
export const ON_BACK_BUTTON_PRESS = "ON_BACK_BUTTON_PRESS";
export const RESET_ROUTE_CHANGE_STATE = "RESET_ROUTE_CHANGE_STATE";
export const UPDATE_APP_LOCATION = "UPDATE_APP_LOCATION";
export const OPTIMIZE_ACTIVATE = "optimize.activate";
export const CLOSE_MODAL = "CLOSE_MODAL";

export const CLOSE_ONE_OFF_MODAL = "CLOSE_ONE_OFF_MODAL";

const App = {
  APP_ERROR,
  REHYDRATION_COMPLETE,
  ROUTE_CHANGE,
  ON_BACK_BUTTON_PRESS,
  RESET_ROUTE_CHANGE_STATE,
  UPDATE_APP_LOCATION,
  OPTIMIZE_ACTIVATE,
  CLEAR_APP_ERRORS,
  CLOSE_MODAL,
  CLOSE_ONE_OFF_MODAL,
};

export default App;
